<template>
  <div v-if="fetching">
    <BaseSpinner
      height="40px"
      width="40px"
      v-if="true"
    />
  </div>
  <form
    @submit.prevent="submitForm"
    class="row"
    v-else
  >
    <div
      class="col-xs-8"
      v-if="fromImport && info.versionNumber !== heighestVersionNumber && !accepted"
    >
      <Box class="dangerZone">
        <p>Der findes allerede en fremtidig version.</p>
        <br>
        <p>Vil du overskrive (og dermed miste alle dine ændringer for) den fremtidige version?</p>
        <br>
        <div class="dangerZone__buttons">
          <BaseButton
            class="col-xs-4"
            label="Nej, jeg vil håndtere dette manuelt."
            @click.prevent="$emit('close')"
          />
          <BaseButton
            label="Ja, fortsæt og overskriv!"
            class="col-xs-4"
            @click.prevent="accepted = true"
          />
        </div>
      </Box>
    </div>
    <div
      class="col-xs-8"
      v-if="info.versionNumber === heighestVersionNumber || accepted"
    >
      <div class="row">
        <div class="col-xs-12 update-close">
          <p @click.prevent="$emit('close')">
            ANNULLER <font-awesome-icon icon="times" />
          </p>
        </div>

        <section class="col-xs-12">
          <Box>
            <BaseInput
              label="ID / navn"
              v-model="info.name"
              :disabled="disableNameInput"
            />

            <BaseFormField label="Publiceringsdato">
              <Datejump v-model="info.publishDate">
                <BaseDatetimePicker v-model="info.publishDate" />
              </Datejump>
            </BaseFormField>

            <BaseFormField label="Status">
              <BaseCheckbox
                label="Slettet"
                v-model="info.deleted"
              />
            </BaseFormField>

            <BaseCheckbox
              label="Udsend notifikation"
              v-model="info.sendNotification"
            />

            <BaseTextarea
              label="Intern note"
              v-model="info.internalNote"
            />
          </Box>

          <Box>
            <BaseFormField class="select-wada">
              <h3>WADA klassicifering</h3>
              <BaseRadioButton
                :value="info.wadaClassification"
                name="selectWADA"
                store=""
                @input="info.wadaClassification = $event"
                label="Ingen klassicificering"
              />
              <BaseRadioButton
                v-for="(wada, wadaIndex) in getAllWADA"
                :key="wadaIndex"
                :value="info.wadaClassification"
                name="selectWADA"
                :store="wada.id"
                @input="info.wadaClassification = $event"
                :label="wada.name"
              />
            </BaseFormField>
          </Box>
        </section>
        <section class="col-xs-12">
          <Box>
            <RouteOfAdministrationStatuses :statuses="routeOfAdministrationStatuses" />
          </Box>

          <Box>
            <GlobalNotesSelector
              :notes="globalNotes"
              :current-date="info.publishDate"
            />
          </Box>

          <Box>
            <LocalNotes
              :notes="localNotes"
              @add="localNotes.push($event)"
              @remove="onRemoveLocalNote"
            />
          </Box>
        </section>
        <div class="col-xs-12">
          <BaseButton
            label="Gem indholdsstof"
            :disabled="loading"
            full
          />
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDatetimePicker from '../../BaseDatetimePicker.vue';
import Datejump from '../../Datejump.vue';
import RouteOfAdministrationStatuses from '../../RouteOfAdministrationStatuses.vue';
import LocalNotes from '../../LocalNotes.vue';
import GlobalNotesSelector from '../../GlobalNotesSelector.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';
import BaseRadioButton from '../../BaseRadioButton.vue';
import Box from '../../Box.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseInput from '../../BaseInput.vue';
import SubstanceService from '../../../services/SubstanceService';
import DefaultDate from '../../../filters/DefaultDate';

export default {
    name: 'UpdateSubstanceForm',
    components: {
        BaseInput,
        BaseFormField,
        BaseTextarea,
        BaseButton,
        BaseSpinner,
        Box,
        BaseRadioButton,
        BaseCheckbox,
        GlobalNotesSelector,
        LocalNotes,
        RouteOfAdministrationStatuses,
        Datejump,
        BaseDatetimePicker,
    },
    props: {
        form: { type: Object, required: true },
        fromImport: { type: Boolean, required: true },
        meta: { type: Object, required: true },
        action: {
            type: String,
            required: true,
            validator(value) {
                return ['update', 'newVersion'].indexOf(value) !== -1;
            },
        },
    },
    data() {
        return {
            loading: false,
            fetching: true,
            info: {
                name: '',
                publishDate: window.moment().endOf('day').format(),
                deleted: false,
                wadaClassification: '',
                internalNote: '',
            },
            localNotes: [],
            globalNotes: [],
            routeOfAdministrationStatuses: [],
            accepted: false,
            formTemp: {},
        };
    },
    computed: {
        ...mapGetters({
            getAllGlobalNotesFromDatetime: 'globalnotes/getAllGlobalNotesFromDatetime',
            getAllWADA: 'wada/getAllWADA',
            getAllRouteOfAdministration: 'routeofadministration/getAllRouteOfAdministration',
        }),
        disableNameInput() {
            if (this.action === 'newVersion') {
                return true;
            }

            if (('versionNumber' in this.info)) {
                if (this.info.versionNumber > 1) {
                    return true;
                }

                return window.moment(this.info.publishDate).isSameOrBefore(window.moment()) && this.info.versionNumber === 1;
            }

            return false;
        },
        formattedIconID() {
            return this.form.iconID === -1 ? null : this.form.iconID;
        },
        mappedRouteOfAdministrationStatuses() {
            return this.routeOfAdministrationStatuses
                .filter(route => (route.statusCompetition > -1 && route.statusTraining > -1))
                .map(route => ({ routeOfAdministrationID: route.id, statusCompetition: route.statusCompetition, statusTraining: route.statusTraining }));
        },
        mappedGlobalNotes() {
            return this.globalNotes.filter(note => note.selected).map(note => ({ id: note.id }));
        },
        requestData() {
            return {
                info: { ...this.info, ...{ publishDate: DefaultDate(this.info.publishDate) } },
                localNotes: this.localNotes,
                globalNotes: this.mappedGlobalNotes,
                routeOfAdministrationStatuses: this.mappedRouteOfAdministrationStatuses,
            };
        },
        heighestVersionNumber() {
            if (this.meta.versions.length === 0) {
                return -1;
            }
            return this.meta.versions.reduce((prev, current) => ((prev.versionNumber > current.versionNumber) ? prev : current)).versionNumber;
        },
    },
    methods: {
        ...mapActions({
            loadGlobalNotes: 'globalnotes/loadGlobalNotes',
            loadWADA: 'wada/loadWADA',
            loadRouteOfAdministration: 'routeofadministration/loadRouteOfAdministration',
        }),
        onRemoveLocalNote(localIndex) {
            this.localNotes = this.localNotes.filter((a, index) => index !== localIndex);
        },
        initGlobalNotes() {
            this.globalNotes = this.getAllGlobalNotesFromDatetime(this.info.publishDate)
                .map(note => ({ ...note, selected: !!this.form.globalNotes.filter(t => t.id === note.id).length }))
                .filter(note => note.deleted === false);
        },
        async submitForm() {
            try {
                this.loading = true;
                let action = 'update';

                if (this.action === 'newVersion') {
                    action = 'newVersion';
                }

                const format = { ...this.requestData };
                if (action === 'newVersion') {
                    delete format.info.versionNumber;
                }

                if (this.info.versionNumber !== this.heighestVersionNumber && this.accepted) {
                    action = 'update';
                    format.info.versionNumber = this.heighestVersionNumber;
                }
                const payload = await SubstanceService[action](format);

                this.$snotify.success(`${payload.info.name} er gemt`);
                this.loading = false;
                this.$emit('saved', { payload, action: this.action });
            } catch (error) {
                this.loading = false;
            }
        },
    },
    async created() {
        try {
            await this.loadGlobalNotes();
            await this.loadWADA();
            await this.loadRouteOfAdministration(this.form.info.id);

            this.info = { ...this.form.info };
            this.localNotes = [...this.form.localNotes];

            this.routeOfAdministrationStatuses = this.getAllRouteOfAdministration.map((route) => {
                const temp = this.form.routeOfAdministrationStatuses.find(r => r.routeOfAdministrationID === route.id);
                if (temp) {
                    return { ...route, ...temp };
                }
                return {
                    ...route, statusCompetition: -1, statusTraining: -1, updatedOnce: false,
                };
            });

            if (this.action === 'newVersion') {
                this.info.internalNote = '';
                this.info.publishDate = window.moment().add(1, 'day').startOf('day').format();
                this.info.sendNotification = true;
            }


            this.initGlobalNotes();
            this.fetching = false;
        } catch (error) {
            //
        }
    },
    watch: {
        'info.publishDate': function temp() { this.initGlobalNotes(); },
    },
};
</script>

<style lang="scss" scoped>
.select-wada /deep/ .form-field__control {
    display: flex;
    flex-direction: column;
}

.update-close {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    user-select: none;
}

.dangerZone {
    font-weight: bold;

    &__buttons {
        display: flex;
        justify-content: space-between;
    }
}
</style>
